import { admitVisit, cancelVisit, checkIn, completeVisit, markNoShow, type VisitDto } from "@repo/data-store";

export interface VisitLifecycleActions {
  checkIn: () => Promise<unknown>;
  admit: () => Promise<unknown>;
  complete: () => Promise<unknown>;
  noShow: () => Promise<unknown>;
  cancel: () => Promise<unknown>;
}

export function useDataStoreVisitActions(visit: VisitDto): VisitLifecycleActions | null {
  if (!visit.visitId) return null;
  const visitId = visit.visitId;
  return {
    checkIn: () => checkIn({ visitId }).isPersisted.promise,
    admit: () => admitVisit({ visitId }).isPersisted.promise,
    complete: () => completeVisit({ visitId }).isPersisted.promise,
    noShow: () => markNoShow({ visitId }).isPersisted.promise,
    cancel: () => cancelVisit({ visitId }).isPersisted.promise,
  };
}
